import type { Client } from '@leoclinic/types';
import { getSupabaseClient } from '../supabase/client';

export interface MyAppointment {
  id: string;
  start_at: string;
  end_at: string;
  status: string;
  notes: string | null;
  treatment_name: string;
  therapist_name: string;
  treatment_duration: number;
}

export class ClientPortalService {
  async linkProfile(): Promise<string | null> {
    const supabase = getSupabaseClient();
    const { data, error } = await supabase.rpc('link_client_to_profile');
    if (error) {
      if (error.message.includes('Could not find the function')) return null;
      throw error;
    }
    return data as string | null;
  }

  async getMyClientRecord(): Promise<Client | null> {
    const supabase = getSupabaseClient();
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return null;

    const { data, error } = await supabase
      .from('clients')
      .select('*')
      .eq('profile_id', user.id)
      .maybeSingle();

    if (error) throw error;
    return data as Client | null;
  }

  async listMyAppointments(): Promise<MyAppointment[]> {
    const supabase = getSupabaseClient();
    const { data, error } = await supabase.rpc('get_my_appointments');
    if (error) throw error;
    return (data ?? []) as MyAppointment[];
  }

  async cancelMyAppointment(appointmentId: string): Promise<void> {
    const supabase = getSupabaseClient();
    const { error: rpcError } = await supabase.rpc('cancel_my_appointment', {
      p_appointment_id: appointmentId,
    });

    if (!rpcError) return;

    if (!rpcError.message.includes('Could not find the function')) {
      throw rpcError;
    }

    const { error } = await supabase
      .from('appointments')
      .update({ status: 'cancelled' })
      .eq('id', appointmentId);
    if (error) throw error;
  }
}

export const clientPortalService = new ClientPortalService();
